<template>
  <div class="termDetails">
    <div v-if="showTitle" class="title lg">客户告知书</div>
    <p>尊敬的客户:</p>
    <p class="indent">感谢您选择本公司为您办理保险业务。本公司是根据保险公司的委托，在保险公司授权的范围内专门代为办理保险业务的保险专业代理机构。为了保护您的合法权益，按照《保险代理人监管规定》及《互联网保险业务监管办法》的要求，本公司应向投保人履行告知义务，现将有关事项告知如下，请仔细阅读。</p>
    <p>
      <div>一、本公司基本情况</div>
      <div>（一）公司名称:【广东智选保险代理有限公司】</div>
      <div class="close">（二）营业场所:【广州市南沙区环市大道中29号2222房】</div>
      <div class="close">（三）许可证名称及编号:【保险中介许可证】，编号【202787000000800】</div>
      <div class="close">（四）许可证有效期:长期有效</div>
      <div class="close">（五）业务范围:【在全国区域内（港、澳、台除外）代理销售保险产品；代理收取保险费；代理相关保险业务的损失勘察和理赔；保险监督管理机构批准的其他业务】。</div>
      <div class="close">（六）经营区域:【全国区域内（港、澳、台除外）】。</div>
      <div class="close">（七）联系方式:【020-61938236】。</div>
    </p>
    <p>二、本公司获取报酬方式：依法向保险公司收取与客户保险合同有关的佣金作为报酬。</p>
    <p>三、根据保险监管部门的规定，只有进行执业登记的人员方可从事保险代理业务，您可通过登录中国银保监会保险中介监管信息系统查询相关业务人员持证情况(http://iir.circ.gov.cn)</p>
    <p>四、请您仔细阅读保险条款，重点关注保险责任、责任免除、被保险人权利义务、免赔额或免赔率的计算、犹豫期解除合同、退保损失、保险新型产品费用扣除及投资风险、健康保险产品等待期等内容，并可要求本公司业务人员对上述内容进行详细讲解。</p>
    <p>五、如果您投保的是一年期以上(不含一年期)的个人人身保险，根据保险监管部门的规定，保险公司应当向您提供由中国银保监会规定基准内容的《人身保险投保提示书》。 《人身保险投保提示书》着重对投保人合法保险权益、投保注意事项等进行提示，为了保护您的合法权益，请您在投保前务必认真阅读《人身保险投保提示书》。</p>
    <p>六、请向本公司业务人员了解《中华人民共和国保险法》等法律法规。对于索赔时效、 保险公司理赔时限、合同中止与失效、未成年人投保限额、保险标的转让、重复保险等相关规定，以及不履行如实告知义务、故意制造保险事故或夸大事故损失、申报年龄不真实等情形导致的法律后果。</p>
    <p>七、根据《中华人民共和国保险法》的规定，保险专业代理机构因过错给投保人、被保险人造成损失的，依法承担赔偿责任。</p>
    <p>八、本公司已按《保险代理人监管规定》缴存了保证金/投保职业责任保险。</p>
    <p>九、本公司、本公司的执行董事及高级管理人员与被代理保险公司或者其他保险中介机构不存在关联关系。</p>
    <p>十、如果您发现本公司从业人员存在误导行为及其他损害您合法权益的行为，请注意保留书面证据或其他证据，可向本公司投诉（电话：【020-61938236】，电子邮件：【xp_iagent@x-peng.cn】)；必要时还可以根据合同约定，申请仲裁或向法院起诉。</p>
    <p class="bold">十一、您应在正确理解并同意接受本告知书全部内容后再继续选择本公司提供的服务。 如您不同意或不理解本告知书内容的，您应拒绝本公司的服务。如您继续购买，则视为您认可并理解本告知书的全部内容。</p>
    <p class="atRight">广东智选保险代理有限公司</p>
  </div>
</template>
<script>
export default {
  name: 'CustomerNotice',
  props: {
    showTitle: {
      type: Boolean,
      default: false
    }
  }
};
</script>
